import React from 'react'
import { TextComponentProps } from './text.types'

export const spanComponent = ({ children, ...props }: TextComponentProps) => (
  <span {...props}>{children}</span>
)

export const presetComponents = {
  text: spanComponent,
  h1: spanComponent,
  h2: spanComponent,
  h3: spanComponent,
  h4: spanComponent,
  h5: spanComponent,
  h6: spanComponent
}
